export default __webpack_public_path__ + "static/media/x33mall-banner-id.e9bc757f.jpg";